import { Component } from "react";
import { AlertTriangle } from "lucide-react";
import { sendErrorReport } from "./ReportError";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, sent: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.details = `${error?.stack || error}\n${info?.componentStack || ""}`;
  }

  send = async () => {
    try {
      await sendErrorReport({ message: `Automatischer Absturzbericht: ${this.state.error?.message || "Unbekannter Fehler"}`, details: this.details || "" });
      this.setState({ sent: true });
    } catch (e) {
      this.setState({ sent: "failed" });
    }
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 noise-bg" data-testid="error-boundary">
        <div className="max-w-sm w-full text-center space-y-4 bg-white rounded-3xl p-8 border border-pink-100">
          <AlertTriangle className="w-12 h-12 text-rose-500 mx-auto" />
          <h1 className="text-2xl font-extrabold">Ups, da ist etwas schiefgelaufen</h1>
          <p className="text-sm text-slate-600">Sende uns den Fehler mit einem Tipp – wir kümmern uns darum.</p>
          {this.state.sent === true ? <p className="text-sm font-semibold text-emerald-600" data-testid="error-boundary-sent">Danke! Der Fehler wurde an uns gesendet.</p> : (
            <button onClick={this.send} data-testid="error-boundary-send" className="w-full h-11 rounded-full pink-gradient text-white font-bold text-sm">Fehler an itzPlay senden</button>
          )}
          {this.state.sent === "failed" && <p className="text-xs text-red-600">Senden fehlgeschlagen – bitte später erneut versuchen.</p>}
          <button onClick={() => window.location.assign("/feed")} data-testid="error-boundary-reload" className="w-full h-11 rounded-full border border-slate-200 font-semibold text-sm">App neu laden</button>
        </div>
      </div>
    );
  }
}
